import useResize from '@/hooks/useResize';
import { useTranslation } from 'react-i18next';
import {
    ContentTitle,
    ContentSection,
    SectionContent,
    ImagePlaceholder,
    CardGrid,
    CardIcon,
    CardTitle,
    CardDescription,
} from '../style';
import { Box, Card, Flex } from '@/layout';

const EHub = () => {

    //   @ts-ignore
    const { t } = useTranslation();
    const { isTablet, isMobile } = useResize();

    const challengeItems = t('pages.index.GoGlobal.eHub.challenges.items', { returnObjects: true }) as Array<{ title: string, icon: string }>;

    return (
        <>
            <Box marginBottom={'20px'}>
                <ContentTitle isMobile={isMobile}>{t('pages.index.GoGlobal.eHub.title')}</ContentTitle>
            </Box>

            <ContentSection isMobile={isMobile}>
                <SectionContent isMobile={isMobile}>
                    {
                        t('pages.index.GoGlobal.eHub.intro').split('\n').map((line, i) => (
                            <span key={i}>{line}<br /><br /></span>
                        ))
                    }
                </SectionContent>
            </ContentSection>

            <ContentSection isMobile={isMobile}>
                <Flex gridGap={'20px'} flexDirection={isMobile ? 'column' : 'row'} justifyContent={'center'} alignContent={'center'}>
                    <Flex justifyContent={'center'} alignContent={'center'} flexDirection={'column'}>
                        <Box marginBottom={'20px'}>
                            <ContentTitle isMobile={isMobile}>{t('pages.index.GoGlobal.eHub.newEra.title')}</ContentTitle>
                        </Box>
                        <SectionContent isMobile={isMobile}>
                            {
                                t('pages.index.GoGlobal.eHub.newEra.content').split('\n').map((line, i) => (
                                    <span key={i}>{line}<br /><br /></span>
                                ))
                            }
                        </SectionContent>
                    </Flex>
                    <Box>
                        <img src="/images/index/goglobal/GoGlobal-1.jpg" alt="GoGlobal" />
                    </Box>
                </Flex>
            </ContentSection>

            <ContentSection isMobile={isMobile}>
                <Box marginBottom={'20px'}>
                    <ContentTitle isMobile={isMobile}>{t('pages.index.GoGlobal.eHub.challenges.title')}</ContentTitle>
                </Box>
                <Box background={'#fff'}>
                    <CardGrid isMobile={isMobile} isTablet={isTablet} gridRepeat={isTablet ? 'repeat(2, 1fr)' : 'repeat(4, 1fr)'} gridGap='40px'>
                        {challengeItems.map((item, index) => (
                            <div key={index}>
                                <CardIcon isMobile={isMobile}>
                                    <img width="100%" src={item.icon} alt={item.title.replace(/<[^>]*>/g, '')} />
                                </CardIcon>
                                <CardTitle isMobile={isMobile}>
                                    {item.title.split('\n').map((line, i) => (
                                        <span key={i}>{line}<br /></span>
                                    ))}
                                </CardTitle>
                            </div>
                        ))}
                    </CardGrid>
                </Box>
                <Box marginTop={'12px'}>
                    <SectionContent isMobile={isMobile}>
                        {
                            t('pages.index.GoGlobal.eHub.challenges.content').split('\n').map((line, i) => (
                                <span key={i}>{line}<br /></span>
                            ))
                        }
                    </SectionContent>
                </Box>
            </ContentSection>

            <ContentSection isMobile={isMobile}>
                <Flex gridGap={'20px'} flexDirection={isMobile ? 'column' : 'row'} justifyContent={'center'} alignContent={'center'}>
                    <Flex justifyContent={'center'} alignContent={'center'} flexDirection={'column'}>
                        <Box marginBottom={'20px'}>
                            <ContentTitle isMobile={isMobile}>{t('pages.index.GoGlobal.eHub.hkAdvantage.title')}</ContentTitle>
                        </Box>
                        <SectionContent isMobile={isMobile}>
                            {
                                t('pages.index.GoGlobal.eHub.hkAdvantage.content').split('\n').map((line, i) => (
                                    <span key={i}>{line}<br /><br /></span>
                                ))
                            }
                        </SectionContent>
                    </Flex>
                    <Box>
                        <img src="/images/index/goglobal/GoGlobal-3.jpg" alt="GoGlobal" />
                    </Box>
                </Flex>
            </ContentSection>
        </>
    );
};

export default EHub;
